import { useTranslation } from 'react-i18next';
import { IMG_PATH } from 'constants/config';

const data = [
  {
    rate: `${IMG_PATH}/star50.svg`,
    text: '第一次使用，才了解原來投資這麼簡單，不用天天提心弔檔',
    name: 'Andy Lin',
    avatar: `${IMG_PATH}/andy.png`,
    location: '高雄，台灣',
  },
  {
    rate: `${IMG_PATH}/star45.svg`,
    text: '以前天天盯盤績效也沒起色，現在交給投資教練，讓我嚴守紀律，不在買高賣低。',
    name: 'Ivy',
    avatar: `${IMG_PATH}/ivy.jpg`,
    location: 'Taipei, Taiwan',
  },
];

const green = '#00c2c5';
const color = '#152f2e';

function Witness() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center py-12">
      <div className="text-4xl font-bold mb-10" style={{ color: green }}>
        {t('使用者見證')}
      </div>

      <div
        className="w-3/4 flex flex-col items-center space-y-8 sm:space-y-0 sm:space-x-8 sm:flex-row sm:items-start sm:w-auto"
        style={{ color }}
      >
        {data.map(({ rate, text, name, avatar, location }) => (
          <div key={name} className="flex flex-col w-full h-56 sm:w-104">
            <img className="w-28 my-4" src={rate} alt="" />

            <div className="text-xl italic sm:w-3/4 mb-8">{text}</div>

            <div className="flex text-xs mt-auto">
              <img className="w-12 h-12 mr-4" src={avatar} alt="" />
              <div className="flex flex-col justify-around">
                <div className="font-semibold">{name}</div>
                <div>{location}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Witness;
